import AIRPORT_LOUNGE_INDEX from './airportLoungeIndex'
import CONTINENT_AIRPORT_INDEX from './continentAirportIndex'
import { REGION_DISPLAY_NAMES } from '../loungePassesConstants'

/**
 * Reverse lookup: lounge experience ID → airport { name, code, country }
 * Built from CONTINENT_AIRPORT_INDEX + AIRPORT_LOUNGE_INDEX.
 */
const LOUNGE_AIRPORT_LOOKUP: Record<string, { name: string, code: string, country: string }> = {}

/**
 * Forward lookup: airport/city code → lounge experience IDs
 * Supports both specific airport codes and multi-airport city codes.
 */
export const AIRPORT_CODE_LOUNGE_INDEX: Record<string, Array<string>> = {}

for (const [region, countries] of Object.entries(CONTINENT_AIRPORT_INDEX)) {
  // Australia groups by city rather than country, so use the region display name as the country
  const isAustralia = region === 'australia'
  for (const country of countries) {
    for (const airport of country.airports) {
      const loungeIds = AIRPORT_LOUNGE_INDEX[airport.id] ?? []
      for (const loungeId of loungeIds) {
        LOUNGE_AIRPORT_LOOKUP[loungeId] = { name: airport.name, code: airport.code, country: isAustralia ? REGION_DISPLAY_NAMES.australia : country.label }
      }
      if (loungeIds.length > 0) {
        AIRPORT_CODE_LOUNGE_INDEX[airport.code] ??= []
        AIRPORT_CODE_LOUNGE_INDEX[airport.code].push(...loungeIds)
      }
    }
  }
}

export default LOUNGE_AIRPORT_LOOKUP
